// Głupie, ale będzie działać
// Do propsa token zapisuję wartość accessTokena, która później jest wykorzystaywana w reuqestach graphql
// Póki nie ma reduxa, to jest to najprostsza metoda trzymania tokena w pamięci
export const TokenStore = {
  token:""
}